const CDN_BASE_URL = 'https://student-static.epamus.com/static';

/**
 * Get CDN URL for static assets
 * @param {string} path - Asset path (e.g., 'images/logo.svg', 'audio/beep.mp3')
 * @returns {string} Full CDN URL
 */
export function getCdnUrl(path) {
  // Remove leading slash if present
  const cleanPath = path.replace(/^\//, '');
  return `${CDN_BASE_URL}/${cleanPath}`;
}

/**
 * Get CDN URL for audio files
 * @param {string} filename - Audio filename (e.g., 'beep.mp3')
 * @returns {string} Full CDN URL
 */
export function getAudioUrl(filename) {
  return getCdnUrl(`audio/${filename}`);
}

/**
 * Get CDN URL for image files
 * @param {string} path - Image path relative to images folder (e.g., 'common/logo.svg')
 * @returns {string} Full CDN URL
 */
export function getImageUrl(path) {
  return getCdnUrl(`images/${path}`);
}

/**
 * Get CDN URL for font files
 * @param {string} filename - Font filename (e.g., 'NotoSans-Bold.woff2')
 * @returns {string} Full CDN URL
 */
export function getFontUrl(filename) {
  return getCdnUrl(`fonts/${filename}`);
}
